/* Vestigium · interacción (SPEC2 §6; estilos en vestigium.css §13). Sin dependencias: si falta un
   elemento, no hace nada. Atributos: data-vg-tilt, -reveal, -arrastre, -contador, -huella, -iman. */
(function () {
	'use strict';
	if (window.vgInteraccion) return;
	window.vgInteraccion = 1;

	var d = document, P = { passive: true }, gen = 0, IO = 'IntersectionObserver' in window;
	function on(el, t, f, o) { el.addEventListener(t, f, o); }
	function mq(q) { return matchMedia(q).matches; }
	function quieto() { return mq('(prefers-reduced-motion: reduce)'); }
	function fino() { return mq('(hover: hover) and (pointer: fine)') && !quieto(); }
	function lim(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
	function cada(s, q, f) { Array.prototype.forEach.call(s.querySelectorAll(q), f); }
	function marca(el, k) { k = '_vg' + k; if (el[k]) return 1; el[k] = 1; }
	function cerca(e, q) { return e.target.closest ? e.target.closest(q) : null; }
	// Puntero en 0–1; caja en caché hasta el próximo scroll/resize
	function pos(el, e) {
		if (!el._vgC || el._vgG !== gen) { el._vgC = el.getBoundingClientRect(); el._vgG = gen; }
		var r = el._vgC;
		return [lim((e.clientX - r.left) / r.width), lim((e.clientY - r.top) / r.height)];
	}
	function sube() { gen++; }
	on(window, 'scroll', sube, P);
	on(window, 'resize', sube, P);
	function sigue(el, fn) {
		var raf = 0, ev;
		on(el, 'pointerenter', function () { el._vgC = 0; }, P);
		on(el, 'pointermove', function (e) {
			if (e.pointerType !== 'mouse') return;
			ev = e;
			raf = raf || requestAnimationFrame(function () { raf = 0; if (ev) fn(pos(el, ev)); });
		}, P);
		on(el, 'pointerleave', function () { ev = 0; fn(); }, P);
	}

	// Precio + valoración en una fila (respaldo del script en línea de snippets/vg-valoracion.liquid)
	function filaPrecio(s) {
		cada(s, '.product__info-container .vg-valoracion', function (v) {
			var c = v.closest('.product__info-container'), it = v, p, k, f;
			while (it.parentElement !== c) it = it.parentElement;
			if (it !== v && it.querySelector('h1,h2,form,[id^="price-"]')) return;
			for (k = c.firstElementChild; k; k = k.nextElementSibling) if (/^price-/.test(k.id)) { p = k; break; }
			if (!p) return;
			f = d.createElement('div');
			f.className = 'vg-fila-precio';
			c.insertBefore(f, p);
			f.appendChild(p);
			f.appendChild(it);
		});
	}

	// 1. Inclinación 3D con brillo; respeta el transform propio
	function inclinar(s) {
		if (quieto()) return;
		cada(s, '[data-vg-tilt], .vg-polaroid, .vg-cert', function (el) {
			if (el.getAttribute('data-vg-tilt') === 'off' || marca(el, 't')) return;
			if (!el.hasAttribute('data-vg-tilt') && (el.parentElement.closest('[data-vg-tilt]') || el.querySelector('[data-vg-tilt]'))) return;
			var act = 0, base = '', raf = 0, x, y, fin, br;
			function pinta() {
				raf = 0;
				el.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * 14).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * 14).toFixed(2) + 'deg) ' + base;
				if (br) br.style.cssText = '--vg-bx:' + Math.round(x * 100) + '%;--vg-by:' + Math.round(y * 100) + '%';
			}
			function mueve(e) {
				if (!act) {
					act = 1;
					clearTimeout(fin);
					el.style.transition = 'none';
					el.style.transform = '';
					var cs = getComputedStyle(el);
					base = cs.transform === 'none' ? '' : cs.transform;
					el.style.transition = 'transform .15s ease-out';
					el._vgC = 0;
					if (br === undefined) {
						br = cs.position === 'static' ? null : el.appendChild(d.createElement('span'));
						if (br) { br.className = 'vg-brillo'; br.setAttribute('aria-hidden', 'true'); }
					}
					el.classList.add('is-vg-inclinado');
				}
				var p = pos(el, e);
				x = p[0];
				y = p[1];
				raf = raf || requestAnimationFrame(pinta);
			}
			function suelta() {
				if (!act) return;
				act = 0;
				cancelAnimationFrame(raf);
				raf = 0;
				el.classList.remove('is-vg-inclinado');
				el.style.transition = 'transform .6s cubic-bezier(.2,.7,.2,1)';
				el.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) ' + base;
				fin = setTimeout(function () { el.style.transform = el.style.transition = ''; }, 650);
			}
			// Con el dedo solo al mantenerlo quieto 140 ms: al deslizar llega pointercancel y no se inclina
			on(el, 'pointermove', function (e) { if (e.pointerType === 'mouse' || act) mueve(e); }, P);
			on(el, 'pointerdown', function (e) {
				if (e.pointerType === 'mouse') return mueve(e);
				clearTimeout(el._vgT);
				el._vgT = setTimeout(function () { mueve(e); }, 140);
			}, P);
			on(el, 'pointerup', function () { clearTimeout(el._vgT); }, P);
			on(el, 'pointerleave', suelta, P);
			on(el, 'pointercancel', function () { clearTimeout(el._vgT); suelta(); }, P);
		});
	}

	// 2. Revelado escalonado; lo visible al cargar no se oculta
	var rio;
	function revelar(s) {
		if (quieto() || !IO || (window.Shopify && Shopify.designMode)) return;
		var els = [], h = innerHeight, w = innerWidth;
		cada(s, '[data-vg-reveal]', function (el) {
			var p = el.parentElement; // en un carrusel que desliza, sin revelado: no hay tarjetas en blanco
			if (p && p.hasAttribute('data-vg-arrastre') && p.scrollWidth > p.clientWidth + 1) return el.classList.add('is-vg-visto');
			if (!marca(el, 'r')) els.push(el);
		});
		if (!els.length) return;
		rio = rio || new IntersectionObserver(function (es) {
			var n = 0;
			es.forEach(function (e) {
				var el = e.target;
				if (!e.isIntersecting) return;
				rio.unobserve(el);
				el.classList.add('is-vg-visto');
				if (el.animate) el.animate([
					{ opacity: 0, translate: '0 26px', rotate: '-1.2deg' },
					{ opacity: 1, translate: '0 0', rotate: '0deg' }
				], { duration: 760, delay: Math.min(n++, 6) * 90, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
			});
		}, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
		els.map(function (el) {
			var r = el.getBoundingClientRect();
			return r.top < h && r.bottom > 0 && r.left < w && r.right > 0;
		}).forEach(function (visto, i) { if (visto) els[i].classList.add('is-vg-visto'); else rio.observe(els[i]); });
		d.documentElement.classList.add('vg-revelar');
	}

	// 7. Cifra que cuenta desde 0,0 al verse
	var cio;
	function contar(el) {
		var txt = el.textContent, ref = el.getAttribute('data-vg-contador'), fin = parseFloat(ref.replace(',', '.')),
			dec = (ref.split(/[.,]/)[1] || '').length, t0 = 0;
		if (isNaN(fin)) return;
		(function paso(t) {
			var k = t0 ? Math.min(1, (t - t0) / 1100) : 0;
			t0 = t0 || t;
			el.textContent = k < 1 ? (fin * (1 - Math.pow(1 - k, 3))).toFixed(dec).replace('.', ',') : txt;
			if (k < 1) requestAnimationFrame(paso);
		})(0);
	}
	function contadores(s) {
		if (quieto() || !IO) return;
		cio = cio || new IntersectionObserver(function (es) {
			es.forEach(function (e) { if (e.isIntersecting) { cio.unobserve(e.target); contar(e.target); } });
		}, { threshold: 0.6 });
		cada(s, '[data-vg-contador]', function (el) { if (!marca(el, 'n')) cio.observe(el); });
	}

	// 8. Arrastre con ratón; al soltar encaja en la tarjeta más cercana
	function encajar(c) {
		var hs = c.children.length === 1 ? c.children[0].children : c.children, cr = c.getBoundingClientRect(),
			cs = getComputedStyle(c), pad = parseFloat(cs.scrollPaddingLeft), m = 1e9;
		if (isNaN(pad)) pad = parseFloat(cs.paddingLeft) || 0; // «max(…)» llega sin resolver
		Array.prototype.forEach.call(hs, function (h) {
			var v = h.getBoundingClientRect().left - cr.left - pad;
			if (h.offsetWidth && Math.abs(v) < Math.abs(m)) m = v;
		});
		if (m !== 1e9) c.scrollBy({ left: m, behavior: quieto() ? 'auto' : 'smooth' });
		setTimeout(function () { c.classList.remove('is-vg-arrastrando'); }, 450);
	}
	function arrastre(s) {
		cada(s, '[data-vg-arrastre]', function (c) {
			if (marca(c, 'a')) return;
			var id = null, x0 = 0, s0 = 0, mov = 0;
			on(c, 'pointerdown', function (e) {
				if (e.pointerType === 'mouse' && !e.button && c.scrollWidth > c.clientWidth + 1) { id = e.pointerId; x0 = e.clientX; s0 = c.scrollLeft; mov = 0; }
			}, P);
			on(c, 'pointermove', function (e) {
				var dx = e.clientX - x0;
				if (e.pointerId !== id || (!mov && Math.abs(dx) < 6)) return;
				if (!mov) {
					mov = 1;
					c.classList.add('is-vg-arrastrando');
					try { c.setPointerCapture(id); } catch (err) {}
					getSelection().removeAllRanges();
				}
				c.scrollLeft = s0 - dx;
			}, P);
			function fin(e) {
				if (e.pointerId !== id) return;
				id = null;
				if (!mov) return;
				c._vgArr = 1;
				setTimeout(function () { c._vgArr = 0; }, 60);
				encajar(c);
			}
			on(c, 'pointerup', fin);
			on(c, 'pointercancel', fin);
			on(c, 'click', function (e) { if (c._vgArr) { e.preventDefault(); e.stopPropagation(); c._vgArr = 0; } }, true);
			on(c, 'dragstart', function (e) { e.preventDefault(); });
		});
	}

	// Los vídeos de los momentos los reproduce su propio elemento (sections/vg-momentos.liquid)

	// 6. Zoom de la galería que sigue al ratón (con el zoom «hover» del tema, manda el suyo)
	function zoom(s) {
		if (!fino() || innerWidth < 750 || d.querySelector('.image-magnify-hover')) return;
		cada(s, 'media-gallery .product-media-container.media-type-image', function (c) {
			var img = c.querySelector('.product__media img');
			if (!img || marca(c, 'z')) return;
			sigue(c, function (p) {
				c.classList.toggle('is-vg-zoom', !!p);
				if (p) img.style.transformOrigin = (p[0] * 100).toFixed(1) + '% ' + (p[1] * 100).toFixed(1) + '%';
			});
		});
	}

	// 4. Botón magnético (escritorio): usa la propiedad translate, no transform
	function iman(s) {
		if (!fino() || innerWidth < 990) return;
		cada(s, '.product-form__submit, [data-vg-iman]', function (b) {
			if (!marca(b, 'i')) sigue(b, function (p) {
				b.style.translate = p ? ((p[0] - 0.5) * 12).toFixed(1) + 'px ' + ((p[1] - 0.5) * 8).toFixed(1) + 'px' : '';
			});
		});
	}

	// 3. Huella al pulsar un botón principal (capa fija aparte)
	var HUELLA = '<svg viewBox="0 0 40 48" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true">' +
		'<path d="M8 35C5 31 4 27 4 23 4 13 11 5 20 5s16 8 16 18c0 4-1 8-3 12" stroke-dasharray="30 3 14 4 40"/>' +
		'<path d="M13 39c-3-3-4.5-8-4.5-13.5C8.5 17 14 10.5 20 10.5S31.5 17 31.5 25c0 5-1 9-3.5 12" stroke-dasharray="22 3 30 4"/>' +
		'<path d="M18 42c-3-3-5-8-5-13 0-7 3-12 7-12s7 5 7 12c0 4-1 9-3 11"/>' +
		'<path d="M20 44c-1.5-3.5-2.5-8.5-2.5-14 0-4.5 1-7.5 2.5-7.5s2.5 3 2.5 7.5c0 3-.5 6-1 8"/></svg>';
	on(d, 'click', function (e) {
		var b = cerca(e, '[data-vg-huella], .button--primary, .product-form__submit, .vg-btn'), r, h;
		if (!b || quieto() || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
		r = b.getBoundingClientRect();
		h = d.createElement('span');
		h.className = 'vg-huella';
		h.innerHTML = HUELLA;
		h.style.cssText = 'left:' + (e.detail ? e.clientX : r.left + r.width / 2) + 'px;top:' + (e.detail ? e.clientY : r.top + r.height / 2) +
			'px;color:' + getComputedStyle(b).color + ';--vg-huella-giro:' + (Math.random() * 40 - 20).toFixed(1) + 'deg';
		d.body.appendChild(h);
		setTimeout(function () { h.remove(); }, 900);
	}, true);

	// 5. El balanceo de las etiquetas de regalo es solo CSS (vestigium.css §13)

	function iniciar(s) {
		s = s && s.querySelectorAll ? s : d;
		[filaPrecio, revelar, inclinar, contadores, arrastre, zoom, iman].forEach(function (f) {
			try { f(s); } catch (err) { /* si una pieza falla, las demás siguen */ }
		});
	}
	if (d.readyState === 'loading') on(d, 'DOMContentLoaded', function () { iniciar(); });
	else iniciar();
	on(d, 'shopify:section:load', function (e) { iniciar(e.target); });
})();
